import { Web3ReactProvider } from "@web3-react/core"
import React, { ReactNode } from "react"

import { getLibrary } from "../utils"

interface ProviderProps {
    children: ReactNode | JSX.Element
}

export function Web3Provider({ children }: ProviderProps) {
    return <Web3ReactProvider getLibrary={getLibrary}>{children}</Web3ReactProvider>
}
